const deleteAPI = {
    Users:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteUser/",
    Apps: "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteAppDetails/",
    Groups:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteGroup/",
    Roles:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteRole/",
    AppForm:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteAppForm/",
    RoleApp:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deletePrivilege/",
    GroupRole:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteGroupRole/",
    UserGroup:
      "https://eqa.datadimens.com:8443/IDENTITY-SERVICE/privileges/deleteUserGroup/",
  };
  
  export default deleteAPI;